module.exports = __webpack_public_path__ + "img/tien-ich.9f8e9a4a.svg";